import { FC, Fragment, useEffect, useState } from "react";
import { Container, TruncatedTd } from "./style";
import Pagination from "components/particles/pagination/pagination";
import Button from "components/particles/primary-button";
import NoDataFound from "components/particles/no-data-found";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import view from "assets/images/view-icon.svg";
import { useUsers } from "./useHook";
import { useSelector } from "react-redux";
import { siteRoutes } from "utils/helpers/enums/routes.enums";
import { useForm } from "react-hook-form";
import { UsersListSearchDTO } from "utils/helpers/models/users.dto";
import { UserDTO } from "utils/helpers/models/user.dto";
import placeHolderImage from "assets/images/place-img.png";
import { GENDER_OPTIONS } from "utils/helpers/constants/gender";

const UserList: FC = () => {
  const [usersData, setUsersData] = useState<any[]>([]);
  const isLoading = useSelector((state: any) => state.user.isLoading);
  const [searchParams, setSearchParams] = useSearchParams();

  const { register, handleSubmit, setValue, getValues } =
    useForm<UsersListSearchDTO>();
  const { getUsers, updateUserStatusById, getUser } = useUsers();
  const [userPaginationState, setUserPaginationState] = useState<any>([]);
  const [searchFilters, setSearchFilters] = useState<UsersListSearchDTO>({
    nameOrEmail: "",
    phoneNumber: "",
    gender: "",
    status: "",
  });

  console.log(userPaginationState, "userPaginationState");

  const location = useLocation();
  const navigate = useNavigate();

  const search = (data: UsersListSearchDTO) => {
  const offset = 0;

  const queryParams = {
    nameOrEmail: data.nameOrEmail || "",
    phoneNumber: data.phoneNumber || "",
    gender: data.gender || "",
    status: data.status || "",
  };

  setSearchFilters(queryParams);
  setSearchParams(queryParams); 

  getUsers(setUsersData, setUserPaginationState, offset, limit, {
    name: queryParams.nameOrEmail,
    mobileNumber: queryParams.phoneNumber,
    gender: queryParams.gender,
    status: queryParams.status,
  });
};

  const reset = () => {
  const emptyFilters = {
    nameOrEmail: "",
    phoneNumber: "",
    gender: "",
    status: "",
  };

  setValue("nameOrEmail", "");
  setValue("phoneNumber", "");
  setValue("gender", "");
  setValue("status", "");
  setSearchFilters(emptyFilters);
  setSearchParams({}); // ⬅️ clear URL

  getUsers(setUsersData, setUserPaginationState);
};



  const limit = 10;

  const fetchNextRecords = (offset: number) => {
    getUsers(
      setUsersData,
      setUserPaginationState,
      offset,
      limit,
      {
        name: searchFilters.nameOrEmail || "",
        mobileNumber: searchFilters.phoneNumber || "",
        gender: searchFilters.gender || "",
        status: searchFilters.status || "",
      }
    );

    const toTopElement = document.getElementById("toTop");
    if (toTopElement) {
      toTopElement.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    // getUsers(setUsersData, setUserPaginationState);
  }, [searchParams]);

  const handleViewPage = (id: string) => {
  navigate(siteRoutes.usersView + `?${searchParams.toString()}`, {
    state: { id },
  });
};


  const toggleUserStatus = async (
    userId: string,
    setUserStatus: Function,
    userData: any[]
  ) => {
    const currentUser = userData.find((user) => user.id === userId);
    if (currentUser) {
      const newStatus = !currentUser.status;
      await updateUserStatusById(userId, setUserStatus, userData, newStatus);
    }
  };

  const columns: any = [
    {
      name: "Name",
      class: "",
    },
    {
      name: "Email",
      class: "",
    },
    {
      name: "Phone Number",
      class: "",
    },
    {
      name: "Gender",
      class: "th",
    },
    {
      name: "Location",
      class: "th",
    },
    {
      name: "Status",
      class: "th",
    },
    {
      name: "Actions",
      class: "th",
    },
  ];
  const handleSearchSubmit = () => {
    handleSubmit((data) => {
      search(data);
    })();
  };

  const handleResetSubmit = () => {
    handleSubmit(() => {
      reset();
    })();
  };

  /////////////////////////////////////////
  useEffect(() => {
    const nameOrEmail = searchParams.get("nameOrEmail") || "";
    const phoneNumber = searchParams.get("phoneNumber") || "";
    const gender = searchParams.get("gender") || "";
    const status = searchParams.get("status") || "";

    const filtersFromParams = {
      nameOrEmail,
      phoneNumber,
      gender,
      status,
    };

    setValue("nameOrEmail", nameOrEmail);
    setValue("phoneNumber", phoneNumber);
    setValue("gender", gender);
    setValue("status", status);
    setSearchFilters(filtersFromParams);

    getUsers(setUsersData, setUserPaginationState, 0, limit, {
      name: nameOrEmail,
      mobileNumber: phoneNumber,
      gender,
      status,
    });
  }, [searchParams]); // ⬅️ run once on mount


  return (
    <Container id="toTop">
      <h1>User List</h1>
      <div className="search-container">
        <div className="input-fields">
          <input
            type="text"
            placeholder="Search By Name"
            {...register("nameOrEmail")}
            onKeyDown={(e) => e.key === "Enter" && handleSearchSubmit()}
          />

          <input
            type="text"
            placeholder="Search By Phone Number"
            {...register("phoneNumber")}
            onKeyDown={(e) => e.key === "Enter" && handleSearchSubmit()}
          />

          <select
            id="gender"
            {...register("gender")}
            onKeyDown={(e) => e.key === "Enter" && handleSearchSubmit()}
          >
            <option value="">Gender</option>
            {GENDER_OPTIONS.map((opt) => (
              <option value={opt.value} key={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>

          <select
            id="status"
            {...register("status")}
            onKeyDown={(e) => e.key === "Enter" && handleSearchSubmit()}
          >
            <option value="">Status</option>
            <option value="True">Active</option>
            <option value="False">Inactive</option>
          </select>

        </div>
        <div className="button-fields">
          <Button
            title="Search"
            width="16rem"
            fill="true"
            onclick={handleSearchSubmit}
          />
          <Button
            title="Reset"
            width="16rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
            onclick={handleResetSubmit}

          />
        </div>
      </div>
      <div className="data-table">
        <table>
          <thead>
            <tr>
              {columns.map((column: any, index: number) => {
                return (
                  <th className={column.class} key={index}>
                    {column.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {usersData?.length > 0 ? (
              usersData?.map((user: UserDTO, index) => (
                <tr key={index}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={
                          user?.image
                            ? user?.image
                            : placeHolderImage
                        }
                        alt="img"
                        className="img"
                      />
                      <p style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                        {user?.name || "-"}
                      </p>
                    </div>
                  </td>
                  <td>{user?.email || "-"}</td>
                  <td>({user?.countryCode})-{user?.mobileNumber || "-"}</td>
                  <td>{user.gender || "-"}</td>
                  <TruncatedTd>{user.address || "-"}</TruncatedTd>
                  <td>
                    <label className="toggle-button">
                      <input
                        type="checkbox"
                        checked={user.status}
                        onChange={(e) => {
                          toggleUserStatus(user.id, setUsersData, usersData);
                        }}
                      />
                      <span className="slider round"></span>
                    </label>
                  </td>
                  <td>
                    <div
                      className=" view-container"
                      onClick={() => handleViewPage(user?.id)}
                    >
                      <img src={view} alt="img" />
                    </div>
                    {/* <img src={deleteIcon} alt='img' onClick={HandleDelete}/> */}
                  </td>
                </tr>
              ))
            ) : (
              <NoDataFound isShow={!isLoading} />
            )}
          </tbody>
        </table>
        {/* )} */}
      </div>
      <Fragment>
        <Pagination
          totalRecords={userPaginationState?.total || 0}
          perPage={limit}
          handleFetchNextRecords={fetchNextRecords}
        />
      </Fragment>
    </Container>
  );
};

export default UserList;
